<template>
  <div class="app-container">
    <!-- 1. 顶部/内容区域 -->
    <div class="main-content">

       <!-- 情况 1: 显示智能问答 (新增的 v-if) -->
  <div v-if="isSmartChat" class="iframe-wrapper">
    <iframe
      src="http://chatbi.jinghongda.net:1357/chat/e4ac67cd1be89c9d?mode=mobile"
      style="width: 100%; height: 100%;"
      frameborder="0"
      allow="microphone">
    </iframe>
  </div>


      <!-- 情况 A: 显示二级菜单列表 (默认状态) -->
      <div v-else-if="!currentIframeUrl" class="menu-panel">
        <div 
          v-for="(group, gIndex) in currentSecondaryMenus" 
          :key="gIndex" 
          class="menu-group"
        >
          <!-- 二级目录标题 -->
          <div v-if="group.meta && group.meta.title" class="group-header">
            <span class="group-title">{{ group.meta.title }}</span>
            <div class="divider">
              <img style="width: 100%" :src="bgT" alt="dark">
            </div>
          </div>

          <!-- 菜单项网格 -->
          <div class="menu-grid">
            <div 
              v-for="item in (group.children || [group])" 
              :key="item.path"
              class="menu-item"
              @click="openIframe(item)"
            >
            <img :src="iconB" alt="dark">
              <span class="text">{{ item.meta?.title || item.name }}</span>
            </div>
          </div>
        </div>
      </div>
     
        
      <!-- 情况 B: 显示 iFrame (点击菜单后) -->
      <div v-else-if="currentIframeUrl" class="iframe-wrapper">
        <iframe 
          :src="currentIframeUrl" 
          frameborder="0" 
          class="the-iframe"
        ></iframe>
      </div>
    </div>

    <!-- 2. 底部 Tab 导航 (一级菜单) -->
    <div class="bottom-tab-bar">
      <div 
        v-for="(tab, index) in tabRoutes" 
        :key="tab.path"
        class="tab-item"
        :class="{ active: activeTab === tab.path }"
        @click="switchTab(tab)"
      >
        <span class="text">{{ tab.meta?.title || tab.name }}</span>
      </div>
      <div class="tab-item" @click="openSmartChat">
        <span class="text">智能问答</span>
      </div>
      <!-- <div class="tab-item" @click="$router.push('/smart-chat')">
        <span class="text">智能问答</span>
      </div> -->
    </div>
  </div>
</template>

<script>
    import { getUserProfile } from "@/api/index";
export default {
  name: 'AppLayout',
  data() {
    return {
      iconB:require("../assets/icon.svg"),
      bgT:require("../assets/bg.svg"),
      showChatBI: false,     // 是否显示智能问答
      activeTab: '',         // 当前选中的一级菜单路径
      currentIframeUrl: '',  // 当前 iframe 要加载的链接
      currentTitle: '',      // 当前页面标题
      reportSystemUrl:''
    }
  },
  computed: {
    // 从 Vuex 获取所有底部路由（一级菜单）
    tabRoutes() {
      return this.$store.state.permission.tabRoutes
    },
    // 获取当前选中的一级菜单对象
    currentTabRoute() {
      return this.tabRoutes.find(r => r.path === this.activeTab)
    },
    // 计算当前一级菜单下的所有二级菜单
    currentSecondaryMenus() {
      if (!this.currentTabRoute) return []
      // 假设路由结构是：一级 -> children(二级) -> children(三级/叶子)
      // 这里我们直接展示一级菜单下的直接子节点
      return this.currentTabRoute.children || []
    }
  },
  created() {
    // 初始化：默认选中第一个 Tab
    if (this.tabRoutes.length > 0) {
      this.activeTab = this.tabRoutes[0].path
    }
    this.getConfigKey("finereport.url").then(res=>{
      this.reportSystemUrl = res.data.msg;
    
    })

  },
  methods: {
    // 切换底部 Tab
    switchTab(tab) {
     
     // if (this.activeTab === tab.path) return
      this.activeTab = tab.path

      console.log(tab)
      // 切换 Tab 时，重置视图回到菜单列表
      this.currentIframeUrl = ''
      this.currentTitle = ''
      this.isSmartChat = false // 👈 切换普通 Tab 时，关闭智能问答
    },
    openSmartChat() {
      this.isSmartChat = true // 👈 打开智能问答
    this.currentIframeUrl = '' // 顺手清空其他状态
    this.activeTab = '' // 取消底部其他 Tab 的高亮
    },
    // 点击二级菜单，打开 iFrame
    openIframe(item) {
    
      const lastPart = item.component.split('/').pop()  
     
      getUserProfile().then(res=>{
        if(lastPart =='cpt'){
          this.currentIframeUrl =  this.reportSystemUrl + '/decision/view/report?'+item.path+'&deptId='+res.data.data.deptId+'&ssoToken='+localStorage.getItem('ssoToken')
        }else if(lastPart =='frm'){
          this.currentIframeUrl =  this.reportSystemUrl + '/decision/view/form?'+item.path+'&deptId='+res.data.data.deptId+'&ssoToken='+localStorage.getItem('ssoToken')
        }else if(lastPart =='fvs'){
          this.currentIframeUrl =  this.reportSystemUrl + '/decision/view/duchamp?'+item.path+'&deptId='+res.data.data.deptId+'&ssoToken='+localStorage.getItem('ssoToken')
        }else if(lastPart =='index'){
          this.currentIframeUrl =  this.reportSystemUrl + '/decision/v10/entry/access/'+item.path+'&deptId='+res.data.data.deptId+'&ssoToken='+localStorage.getItem('ssoToken')
        
        }
          
      })
     
      
       //this.currentIframeUrl =  this.reportSystemUrl + '/decision/view/report?'+item.path+'?ssoToken='+localStorage.getItem('userToken')
      // console.log(res.data.msg)

      // 这里的 item 就是你的二级或三级菜单对象
      // 假设后端返回的路由里有一个字段叫 iframeUrl 或者 path 就是外链
      // const url = item.meta?.iframeUrl || item.path 
      
      // if (url) {
      //   this.currentTitle = item.meta?.title || '页面'
      //   this.currentIframeUrl = url
      // } else {
      //   console.warn('该菜单未配置跳转链接', item)
      // }
    },

    // 关闭 iFrame，返回菜单列表
    closeIframe() {
      this.currentIframeUrl = ''
      this.currentTitle = ''
    }
  }
}
</script>

<style scoped>
/* --- 基础布局 --- */
.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;
}

.main-content {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  position: relative;
}

/* --- 菜单样式 (还原设计图) --- */
.menu-group {
  margin-bottom: 10px;
  padding: 10px;
  background: #fff;
}

.group-header {
  display: flex;
  padding-bottom: 10px;
  justify-content: space-between;
  /* align-items: center; */
  margin-bottom: 15px;
  border-bottom: 2px dashed #e4e1e1;
}

.group-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.divider {
  width: 32%;
}

.menu-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 两列 */
  gap: 15px;
}

.menu-item {
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  /* text-align: center;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05); */
  display: flex;
  /* justify-content: center; */
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  border: 1px solid #f7efef;

}

.menu-item:active {
  background: #f0f0f0;
}

.icon {
  /* display: block;
  font-size: 24px; */
  
}

.text {
  margin-left: 10px;
  font-size: 12px;
  color: #555;
}

/* --- iFrame 区域样式 --- */
.iframe-wrapper {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: #fff;
  z-index: 10;
  display: flex;
  flex-direction: column;
}

.iframe-header {
  height: 50px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  padding: 0 15px;
  background: #fff;
}

.back-btn {
  color: #1890ff;
  margin-right: 15px;
  cursor: pointer;
}

.the-iframe {
  flex: 1;
  width: 100%;
}

/* --- 底部 Tab 样式 --- */
.bottom-tab-bar {
  height: 50px;
  background: #fff;
  border-top: 1px solid #eee;
  display: flex;
  font-size: 16px;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
}

.tab-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #666;
  font-size: 12px;
}

.tab-item.active {
  color: #1890ff; /* 选中高亮色 */
}
</style>